export const REGISTER_REQUEST: 'REGISTER_REQUEST' = 'REGISTER_REQUEST';
export const REGISTER_SUCCESS: 'REGISTER_SUCCESS' = 'REGISTER_SUCCESS';
export const REGISTER_FAILED: 'REGISTER_FAIL' = 'REGISTER_FAIL';

export const LOGIN_REQUEST: 'LOGIN_REQUEST' = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS: 'LOGIN_SUCCESS' = 'LOGIN_SUCCESS';
export const LOGIN_FAILED: 'LOGIN_FAILED' = 'LOGIN_FAILED';

export const LOGOUT_REQUEST: 'LOGOUT_REQUEST' = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS: 'LOGOUT_SUCCESS' = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILED: 'LOGOUT_FAILED' = 'LOGOUT_FAILED';

export const GET_USER_REQUEST: 'GET_USER_REQUEST' = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS: 'GET_USER_SUCCESS' = 'GET_USER_SUCCESS';
export const GET_USER_FAILED: 'GET_USER_FAILED' = 'GET_USER_FAILED';

export const UPDATE_USER_REQUEST: 'UPDATE_USER_REQUEST' = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS' = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILED: 'UPDATE_USER_FAILED' = 'UPDATE_USER_FAILED';

export const UPDATE_PWD_REQUEST: 'UPDATE_PWD_REQUEST' = 'UPDATE_PWD_REQUEST';
export const UPDATE_PWD_SUCCESS: 'UPDATE_PWD_SUCCESS' = 'UPDATE_PWD_SUCCESS';
export const UPDATE_PWD_FAILED: 'UPDATE_PWD_FAILED' = 'UPDATE_PWD_FAILED';

export const SUBMIT_PWD_REQUEST: 'SUBMIT_PWD_REQUEST' = 'SUBMIT_PWD_REQUEST';
export const SUBMIT_PWD_SUCCESS: 'SUBMIT_PWD_SUCCESS' = 'SUBMIT_PWD_SUCCESS';
export const SUBMIT_PWD_FAILED: 'SUBMIT_PWD_FAILED' = 'SUBMIT_PWD_FAILED';

export const UPDATE_TOKEN_REQUEST: 'UPDATE_TOKEN_REQUEST' = 'UPDATE_TOKEN_REQUEST';
export const UPDATE_TOKEN_SUCCESS: 'UPDATE_TOKEN_SUCCESS' = 'UPDATE_TOKEN_SUCCESS';
export const UPDATE_TOKEN_FAILED: 'UPDATE_TOKEN_FAILED' = 'UPDATE_TOKEN_FAILED';

export const SET_PASSWORD: 'SET_PASSWORD' = 'SET_PASSWORD';
